import { Observable } from 'rxjs';

import { DetectionToken } from '@shure/cloud/shared/models/devices';

export abstract class DetectionTokenApiService {
	public abstract detectionToken$(): Observable<DetectionToken>;
}
